module.exports = __webpack_public_path__ + "static/assets/f74f5d9c47dd4808fd0cdd3f82b5b59d.svg";